module.exports = __webpack_public_path__ + "static/media/arrow.3d36de1e.svg";